module.exports = "<div class=\"wrapper {{ contentClass }}\">\n  <ng-content></ng-content>\n  <a *ngIf=\"showBtn\" tabindex=\"0\" id=\"{{_prefix?.page}}-btn-show-more-{{_prefix?.component}}\" class=\"action-btn\" (click)=\"switchBtn()\">\n    <i [ngClass]=\"{ 'icon-Showmore': !isDisplayAll, 'icon-arrow-show-less-round': isDisplayAll }\"></i>\n      <span>{{ (!isDisplayAll ? 'show-more-btn' : 'show-less-btn') | translate}}</span>\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/show-more-content-box/show-more-content-box.component.html
// module id = 1086
// module chunks = 22